import React from "react";

import ReactFlow, {
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  useReactFlow,
} from "react-flow-renderer";

const Graph = ({ initialNodes, initialEdges, setSelectedNode }) => {
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, , onEdgesChange] = useEdgesState(initialEdges);

  const { zoomOut } = useReactFlow();

  const handleGraphInit = () => {
    if (initialNodes.length < 5) zoomOut({ duration: 500 });
  };

  const handleNodeClick = (e, node) => {
    if (e) {
      setSelectedNode(
        node.type === "output" || !node.selectable ? undefined : node
      );
    }
  };

  return (
    <div className="h-full bg-white dark:bg-gray-800 border-2">
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onInit={handleGraphInit}
        onNodeClick={handleNodeClick}
        deleteKeyCode={[]}
        attributionPosition="top-right"
        fitView
      >
        <Controls />
        <Background color="#ffffff" gap={16} />
      </ReactFlow>
    </div>
  );
};

export default Graph;
